import { Grid, Typography } from '@mui/material'

import { CircleAlertIcon } from 'src/assets/icons'

import { useStyles } from './styles'

interface IProps {
  text: string
}

const NotFoundCard = ({ text }: IProps) => {
  const classes = useStyles()

  return (
    <Grid className={classes.notFoundWrapper}>
      <Grid>
        <CircleAlertIcon />
      </Grid>
      <Grid>
        <Typography className={classes.notFoundTitle}>Oops!</Typography>
      </Grid>
      <Grid>
        <Typography className={classes.notFoundDescription}>{text}</Typography>
      </Grid>
    </Grid>
  )
}

export { NotFoundCard }
